import type { ComparisonOperator } from 'api/schemas/comparisonOperator';

import { formatInstructionComparisonOperator } from '../formatInstructionComparisonOperator/formatInstructionComparisonOperator';
import { formatThreshold } from '../formatThreshold/formatThreshold';

export const formatComparisonThreshold = (
  comparisonOperator: ComparisonOperator | null,
  thresholdValue: number | null
) => {
  if (comparisonOperator == null || thresholdValue == null) {
    return null;
  }

  return `${formatInstructionComparisonOperator(comparisonOperator)} ${formatThreshold(thresholdValue)}`;
};
